import React from 'react';
import { Table, Container } from 'react-bootstrap';

import "../../../css/DataTable.css"


function DataTable({ columns, rows }) {
  if (!columns || columns.length === 0) {
    return <p>No columns available</p>;
  }

  return (
    <Container className="data-table-container">
      <Table striped bordered hover responsive className="data-table">
        <thead>
          <tr>
            {columns.map((col) => (
              <th key={col}>{col}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows && rows.length > 0 ? (
            rows.map((row, idx) => (
              <tr key={idx}>
                {columns.map((col) => (
                  <td key={col}>
                    {row[col] !== null && row[col] !== undefined ? row[col] : '-'}
                  </td>
                ))}
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={columns.length} className="text-center">
                Nessun dato presente
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </Container>
  );
}

export default DataTable;
